import {
  GridCellProps,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { EnumerationCell } from "../../../Layout/Grid/Cell/Default/EnumCell";
import { GridRowClickProps } from "../../../Layout/Grid/GridRowClickProps";
import { projectStateAsString } from "../../ViewModel/ProjectState";

export function ProjectStateEnumCell(props: GridCellProps & GridRowClickProps) {
  return <EnumerationCell {...props} mapping={projectStateAsString} />;
}

export const projectStateColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[{ State: "Sandbox" }, { State: "Proposed" }, { State: "Active" }]}
    searchBox={() => null}
    {...props}
  />
);
